import { api } from "../services";
export const retryAuth = () => {
  return api.home.checkOneTimeLink(JSON.parse(localStorage.getItem("oneTimeString"))).then((res) => {
    if (!res || !res.success) window.location="#/something-went-wrong"
    res.data.token && res.data.token.length && localStorage.setItem("token", res.data.token);
    res.data.refreshKey && res.data.refreshKey.length && localStorage.setItem("refreshKey", res.data.refreshKey);
  });
};
